module.exports = __webpack_public_path__ + "static/author-1-8a28dfbff00f528ae0332497bc406db4.jpg";